import { Device } from "@capacitor/device";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Notifications } from "./Notifications";
import logger from "@/plugins/logger";

const Downloader = () => {
  const saveFile = async (base64: string, filename: string, mime: string) => {
    // logger.log("Blob ", blob);
    const device = (await Device.getInfo()).platform;
    try {
      if (device == "web") {
        const a = document.createElement("a"); //Create <a>
        a.href = base64; //Image Base64 Goes here
        a.download = filename; //File name Here
        a.click(); //Downloaded file
      } else {
        logger.log("Filename ", filename);
        logger.log("Mime ", mime);
        const temp2 = await Filesystem.requestPermissions();
        if (temp2.publicStorage == "granted") {
          logger.log("Saving file... ", filename);
          const res = await Filesystem.writeFile({
            path: `zeroeight/${filename}`,
            recursive: true,
            data: base64,
            directory: Directory.Documents,
          });
          logger.log("Finished saving file... ", filename, res);
        }

        logger.log("Save file res : ", temp2);
      }
    } catch (err) {
      Notifications.createErrorNotification(err as string);
    }
  };

  const generatePdfAndSave = async (table: {
    fileName: string;
    columns: { header: string; dataKey: string }[];
    body: any[];
    horizontalPageBreak?: boolean;
    horizontalPageBreakRepeat?: string;
    horizontalPageBreakBehaviour?: "immediately" | "afterAllRows";
  }) => {
    // Text obj { name, x, y }
    // path
    // autotable { columns, horizontalPageBreakRepeat}

    const doc = new jsPDF({
      orientation: "l",
      compress: true,
    });
    // doc.text(text.name, text.x, text.y);
    doc.setFontSize(40);
    const textWidth =
      (doc.getStringUnitWidth(table.fileName) * doc.getFontSize()) /
      doc.internal.scaleFactor;
    const textOffset = (doc.internal.pageSize.width - textWidth) / 2;

    doc.text(table.fileName, textOffset, 70);

    const img = new Image();
    img.src = require("@/assets/logoPWAtrans.png");
    doc.addImage(img, "png", 100, 50, 100, 100, undefined, "FAST");
    // Calculate the center for the logo
    // const pageWidth = doc.internal.pageSize.width;
    // const logoWidth = 50; // Adjust to your desired width
    // const logoHeight = 20; // Adjust to your desired height
    // const logoX = (pageWidth - logoWidth) / 2;

    // // Add the logo below the title (using y = 25 to position well below title)
    // doc.addImage(
    //   img,
    //   "png",
    //   logoX,
    //   30,
    //   logoWidth,
    //   logoHeight,
    //   undefined,
    //   "FAST"
    // );
    doc.addPage("l");
    autoTable(doc, {
      /* head: head, */
      body: table.body,
      columns: table.columns,
      startY: 45,
      pageBreak: "avoid",
      styles: { overflow: "linebreak", fontSize: 5, cellWidth: "wrap" },
      horizontalPageBreak: table.horizontalPageBreak || false,
      horizontalPageBreakRepeat: table.horizontalPageBreakRepeat,
      horizontalPageBreakBehaviour:
        table.horizontalPageBreakBehaviour || "immediately",
      rowPageBreak: "avoid",
      // didDrawCell: (data) => {
      //   logger.log(data.column.index);
      // },
    });

    const devInfo = await Device.getInfo();
    if (devInfo.platform == "web") {
      doc.save(`${table.fileName}.pdf`);
    } else {
      try {
        const output = doc.output("datauristring");
        logger.log("Output for pdf: ", output);
        if (typeof output == "string") {
          await saveFile(output, "ActivityLog.pdf", "application/pdf");
        }
        return Promise.resolve();
      } catch (err) {
        logger.log(
          "Error: ",
          JSON.stringify(err, ["message", "arguments", "type", "name"])
        );
        return Promise.reject(err);
      }
    }
  };
  return {
    generatePdfAndSave,
    saveFile,
  };
};

const temp = Downloader();

export default temp;
